import { paths as CustomerCommunicationPaths } from '@luxuryescapes/contract-customer-communication';

import { json_headers, request } from '~/services/common';

import { makeCustomerCommunicationV1URL } from './customerCommunicationRequestUtils';

type HeroPlannerSchedulePostContract =
  CustomerCommunicationPaths['/api/customer-communication/v1/todays-escapes-schedule/hero-planner/send-test-email']['post'];

function mapNewExternalHeroPlannerTestEmailPayload(
  brand: string,
  scheduleId: string,
  subjectLine: string,
  recipientEmails: Array<string>,
  scheduleType?: CustomerCommunication.ScheduleType,
): HeroPlannerSchedulePostContract['requestBody']['content']['application/json'] {
  return {
    brand: brand as HeroPlannerSchedulePostContract['requestBody']['content']['application/json']['brand'],
    scheduleId,
    subjectLine,
    recipientEmails,
    scheduleType,
  };
}

async function requestPostHeroPlannerTestEmail(
  brand: string,
  scheduleId: string,
  subjectLine: string,
  recipientEmails: Array<string>,
  scheduleType?: CustomerCommunication.ScheduleType,
) {
  if (!scheduleId) throw 'missing scheduleId';
  if (!subjectLine) throw 'missing subjectLine';
  if (!recipientEmails.length) throw 'missing recipientEmails';

  const url = makeCustomerCommunicationV1URL('/todays-escapes-schedule/hero-planner/send-test-email');

  return request(url.toString(), {
    method: 'POST',
    credentials: 'include',
    headers: json_headers,
    body: JSON.stringify(
      mapNewExternalHeroPlannerTestEmailPayload(brand, scheduleId, subjectLine, recipientEmails, scheduleType),
    ),
  })
    .then(() => {
      return undefined;
    })
    .catch((error) => {
      throw JSON.stringify(error, null, 2);
    });
}

export default requestPostHeroPlannerTestEmail;
